export const mapToObj = (arrayToMap, onField, valueField) => {
  return arrayToMap.reduce((acc, obj) => {
    acc[obj[onField]] = obj[valueField];
    return acc;
  }, {});
};
